// Melbourne suburbs served — powers per-suburb SEO landing pages at /removalists/<slug>
// 314 suburb/locality landing pages across Greater Melbourne.
export const SUBURBS = [
  { slug: "melbourne-cbd", name: "Melbourne CBD", region: "Inner Melbourne & CBD" },
  { slug: "carlton", name: "Carlton", region: "Inner Melbourne & CBD" },
  { slug: "carlton-north", name: "Carlton North", region: "Inner Melbourne & CBD" },
  { slug: "docklands", name: "Docklands", region: "Inner Melbourne & CBD" },
  { slug: "east-melbourne", name: "East Melbourne", region: "Inner Melbourne & CBD" },
  { slug: "flemington", name: "Flemington", region: "Inner Melbourne & CBD" },
  { slug: "kensington", name: "Kensington", region: "Inner Melbourne & CBD" },
  { slug: "north-melbourne", name: "North Melbourne", region: "Inner Melbourne & CBD" },
  { slug: "parkville", name: "Parkville", region: "Inner Melbourne & CBD" },
  { slug: "southbank", name: "Southbank", region: "Inner Melbourne & CBD" },
  { slug: "south-wharf", name: "South Wharf", region: "Inner Melbourne & CBD" },
  { slug: "west-melbourne", name: "West Melbourne", region: "Inner Melbourne & CBD" },
  { slug: "port-melbourne", name: "Port Melbourne", region: "Inner Melbourne & CBD" },
  { slug: "albert-park", name: "Albert Park", region: "Inner Melbourne & CBD" },
  { slug: "middle-park", name: "Middle Park", region: "Inner Melbourne & CBD" },
  { slug: "st-kilda", name: "St Kilda", region: "Inner Melbourne & CBD" },
  { slug: "st-kilda-east", name: "St Kilda East", region: "Inner Melbourne & CBD" },
  { slug: "st-kilda-west", name: "St Kilda West", region: "Inner Melbourne & CBD" },
  { slug: "balaclava", name: "Balaclava", region: "Inner Melbourne & CBD" },
  { slug: "elwood", name: "Elwood", region: "Inner Melbourne & CBD" },
  { slug: "ripponlea", name: "Ripponlea", region: "Inner Melbourne & CBD" },
  { slug: "south-yarra", name: "South Yarra", region: "Inner Melbourne & CBD" },
  { slug: "prahran", name: "Prahran", region: "Inner Melbourne & CBD" },
  { slug: "windsor", name: "Windsor", region: "Inner Melbourne & CBD" },
  { slug: "toorak", name: "Toorak", region: "Inner Melbourne & CBD" },
  { slug: "richmond", name: "Richmond", region: "Inner Melbourne & CBD" },
  { slug: "burnley", name: "Burnley", region: "Inner Melbourne & CBD" },
  { slug: "cremorne", name: "Cremorne", region: "Inner Melbourne & CBD" },
  { slug: "abbotsford", name: "Abbotsford", region: "Inner Melbourne & CBD" },
  { slug: "collingwood", name: "Collingwood", region: "Inner Melbourne & CBD" },
  { slug: "fitzroy", name: "Fitzroy", region: "Inner Melbourne & CBD" },
  { slug: "fitzroy-north", name: "Fitzroy North", region: "Inner Melbourne & CBD" },
  { slug: "clifton-hill", name: "Clifton Hill", region: "Inner Melbourne & CBD" },
  { slug: "northcote", name: "Northcote", region: "Inner Melbourne & CBD" },
  { slug: "thornbury", name: "Thornbury", region: "Inner Melbourne & CBD" },
  { slug: "fairfield", name: "Fairfield", region: "Inner Melbourne & CBD" },
  { slug: "alphington", name: "Alphington", region: "Inner Melbourne & CBD" },
  { slug: "ivanhoe", name: "Ivanhoe", region: "Inner Melbourne & CBD" },
  { slug: "ivanhoe-east", name: "Ivanhoe East", region: "Inner Melbourne & CBD" },
  { slug: "heidelberg", name: "Heidelberg", region: "Inner Melbourne & CBD" },
  { slug: "heidelberg-west", name: "Heidelberg West", region: "Inner Melbourne & CBD" },
  { slug: "eaglemont", name: "Eaglemont", region: "Inner Melbourne & CBD" },
  { slug: "brunswick", name: "Brunswick", region: "North & North-West" },
  { slug: "brunswick-east", name: "Brunswick East", region: "North & North-West" },
  { slug: "brunswick-west", name: "Brunswick West", region: "North & North-West" },
  { slug: "coburg", name: "Coburg", region: "North & North-West" },
  { slug: "coburg-north", name: "Coburg North", region: "North & North-West" },
  { slug: "pascoe-vale", name: "Pascoe Vale", region: "North & North-West" },
  { slug: "pascoe-vale-south", name: "Pascoe Vale South", region: "North & North-West" },
  { slug: "oak-park", name: "Oak Park", region: "North & North-West" },
  { slug: "glenroy", name: "Glenroy", region: "North & North-West" },
  { slug: "hadfield", name: "Hadfield", region: "North & North-West" },
  { slug: "fawkner", name: "Fawkner", region: "North & North-West" },
  { slug: "reservoir", name: "Reservoir", region: "North & North-West" },
  { slug: "preston", name: "Preston", region: "North & North-West" },
  { slug: "bundoora", name: "Bundoora", region: "North & North-West" },
  { slug: "thomastown", name: "Thomastown", region: "North & North-West" },
  { slug: "lalor", name: "Lalor", region: "North & North-West" },
  { slug: "epping", name: "Epping", region: "North & North-West" },
  { slug: "south-morang", name: "South Morang", region: "North & North-West" },
  { slug: "mill-park", name: "Mill Park", region: "North & North-West" },
  { slug: "doreen", name: "Doreen", region: "North & North-West" },
  { slug: "mernda", name: "Mernda", region: "North & North-West" },
  { slug: "wollert", name: "Wollert", region: "North & North-West" },
  { slug: "craigieburn", name: "Craigieburn", region: "North & North-West" },
  { slug: "roxburgh-park", name: "Roxburgh Park", region: "North & North-West" },
  { slug: "broadmeadows", name: "Broadmeadows", region: "North & North-West" },
  { slug: "campbellfield", name: "Campbellfield", region: "North & North-West" },
  { slug: "dallas", name: "Dallas", region: "North & North-West" },
  { slug: "coolaroo", name: "Coolaroo", region: "North & North-West" },
  { slug: "meadow-heights", name: "Meadow Heights", region: "North & North-West" },
  { slug: "tullamarine", name: "Tullamarine", region: "North & North-West" },
  { slug: "airport-west", name: "Airport West", region: "North & North-West" },
  { slug: "keilor-east", name: "Keilor East", region: "North & North-West" },
  { slug: "keilor-park", name: "Keilor Park", region: "North & North-West" },
  { slug: "keilor", name: "Keilor", region: "North & North-West" },
  { slug: "avondale-heights", name: "Avondale Heights", region: "North & North-West" },
  { slug: "essendon", name: "Essendon", region: "North & North-West" },
  { slug: "essendon-north", name: "Essendon North", region: "North & North-West" },
  { slug: "essendon-west", name: "Essendon West", region: "North & North-West" },
  { slug: "moonee-ponds", name: "Moonee Ponds", region: "North & North-West" },
  { slug: "ascot-vale", name: "Ascot Vale", region: "North & North-West" },
  { slug: "strathmore", name: "Strathmore", region: "North & North-West" },
  { slug: "niddrie", name: "Niddrie", region: "North & North-West" },
  { slug: "maribyrnong", name: "Maribyrnong", region: "West & Western Suburbs" },
  { slug: "footscray", name: "Footscray", region: "West & Western Suburbs" },
  { slug: "seddon", name: "Seddon", region: "West & Western Suburbs" },
  { slug: "yarraville", name: "Yarraville", region: "West & Western Suburbs" },
  { slug: "kingsville", name: "Kingsville", region: "West & Western Suburbs" },
  { slug: "west-footscray", name: "West Footscray", region: "West & Western Suburbs" },
  { slug: "braybrook", name: "Braybrook", region: "West & Western Suburbs" },
  { slug: "sunshine", name: "Sunshine", region: "West & Western Suburbs" },
  { slug: "sunshine-west", name: "Sunshine West", region: "West & Western Suburbs" },
  { slug: "albion", name: "Albion", region: "West & Western Suburbs" },
  { slug: "ardeer", name: "Ardeer", region: "West & Western Suburbs" },
  { slug: "deer-park", name: "Deer Park", region: "West & Western Suburbs" },
  { slug: "caroline-springs", name: "Caroline Springs", region: "West & Western Suburbs" },
  { slug: "burnside", name: "Burnside", region: "West & Western Suburbs" },
  { slug: "burnside-heights", name: "Burnside Heights", region: "West & Western Suburbs" },
  { slug: "taylors-lakes", name: "Taylors Lakes", region: "West & Western Suburbs" },
  { slug: "sydenham", name: "Sydenham", region: "West & Western Suburbs" },
  { slug: "hillside", name: "Hillside", region: "West & Western Suburbs" },
  { slug: "aintree", name: "Aintree", region: "West & Western Suburbs" },
  { slug: "rockbank", name: "Rockbank", region: "West & Western Suburbs" },
  { slug: "truganina", name: "Truganina", region: "West & Western Suburbs" },
  { slug: "tarneit", name: "Tarneit", region: "West & Western Suburbs" },
  { slug: "wyndham-vale", name: "Wyndham Vale", region: "West & Western Suburbs" },
  { slug: "hoppers-crossing", name: "Hoppers Crossing", region: "West & Western Suburbs" },
  { slug: "point-cook", name: "Point Cook", region: "West & Western Suburbs" },
  { slug: "williams-landing", name: "Williams Landing", region: "West & Western Suburbs" },
  { slug: "williamstown", name: "Williamstown", region: "West & Western Suburbs" },
  { slug: "newport", name: "Newport", region: "West & Western Suburbs" },
  { slug: "altona", name: "Altona", region: "West & Western Suburbs" },
  { slug: "altona-north", name: "Altona North", region: "West & Western Suburbs" },
  { slug: "altona-meadows", name: "Altona Meadows", region: "West & Western Suburbs" },
  { slug: "laverton", name: "Laverton", region: "West & Western Suburbs" },
  { slug: "laverton-north", name: "Laverton North", region: "West & Western Suburbs" },
  { slug: "brooklyn", name: "Brooklyn", region: "West & Western Suburbs" },
  { slug: "greensborough", name: "Greensborough", region: "North-East Suburbs" },
  { slug: "watsonia", name: "Watsonia", region: "North-East Suburbs" },
  { slug: "watsonia-north", name: "Watsonia North", region: "North-East Suburbs" },
  { slug: "macleod", name: "Macleod", region: "North-East Suburbs" },
  { slug: "rosanna", name: "Rosanna", region: "North-East Suburbs" },
  { slug: "viewbank", name: "Viewbank", region: "North-East Suburbs" },
  { slug: "briar-hill", name: "Briar Hill", region: "North-East Suburbs" },
  { slug: "montmorency", name: "Montmorency", region: "North-East Suburbs" },
  { slug: "eltham", name: "Eltham", region: "North-East Suburbs" },
  { slug: "eltham-north", name: "Eltham North", region: "North-East Suburbs" },
  { slug: "research", name: "Research", region: "North-East Suburbs" },
  { slug: "wattle-glen", name: "Wattle Glen", region: "North-East Suburbs" },
  { slug: "diamond-creek", name: "Diamond Creek", region: "North-East Suburbs" },
  { slug: "plenty", name: "Plenty", region: "North-East Suburbs" },
  { slug: "yallambie", name: "Yallambie", region: "North-East Suburbs" },
  { slug: "balwyn", name: "Balwyn", region: "Inner East" },
  { slug: "balwyn-north", name: "Balwyn North", region: "Inner East" },
  { slug: "kew", name: "Kew", region: "Inner East" },
  { slug: "kew-east", name: "Kew East", region: "Inner East" },
  { slug: "hawthorn", name: "Hawthorn", region: "Inner East" },
  { slug: "hawthorn-east", name: "Hawthorn East", region: "Inner East" },
  { slug: "camberwell", name: "Camberwell", region: "Inner East" },
  { slug: "canterbury", name: "Canterbury", region: "Inner East" },
  { slug: "surrey-hills", name: "Surrey Hills", region: "Inner East" },
  { slug: "mont-albert", name: "Mont Albert", region: "Inner East" },
  { slug: "mont-albert-north", name: "Mont Albert North", region: "Inner East" },
  { slug: "box-hill", name: "Box Hill", region: "Eastern Suburbs" },
  { slug: "box-hill-north", name: "Box Hill North", region: "Eastern Suburbs" },
  { slug: "box-hill-south", name: "Box Hill South", region: "Eastern Suburbs" },
  { slug: "blackburn", name: "Blackburn", region: "Eastern Suburbs" },
  { slug: "blackburn-north", name: "Blackburn North", region: "Eastern Suburbs" },
  { slug: "blackburn-south", name: "Blackburn South", region: "Eastern Suburbs" },
  { slug: "nunawading", name: "Nunawading", region: "Eastern Suburbs" },
  { slug: "mitcham", name: "Mitcham", region: "Eastern Suburbs" },
  { slug: "donvale", name: "Donvale", region: "Eastern Suburbs" },
  { slug: "doncaster", name: "Doncaster", region: "Eastern Suburbs" },
  { slug: "doncaster-east", name: "Doncaster East", region: "Eastern Suburbs" },
  { slug: "templestowe", name: "Templestowe", region: "Eastern Suburbs" },
  { slug: "templestowe-lower", name: "Templestowe Lower", region: "Eastern Suburbs" },
  { slug: "bulleen", name: "Bulleen", region: "Eastern Suburbs" },
  { slug: "burwood", name: "Burwood", region: "Eastern Suburbs" },
  { slug: "burwood-east", name: "Burwood East", region: "Eastern Suburbs" },
  { slug: "ashwood", name: "Ashwood", region: "Eastern Suburbs" },
  { slug: "ashburton", name: "Ashburton", region: "Eastern Suburbs" },
  { slug: "chadstone", name: "Chadstone", region: "Eastern Suburbs" },
  { slug: "mount-waverley", name: "Mount Waverley", region: "Eastern Suburbs" },
  { slug: "glen-waverley", name: "Glen Waverley", region: "Eastern Suburbs" },
  { slug: "wheelers-hill", name: "Wheelers Hill", region: "Eastern Suburbs" },
  { slug: "mulgrave", name: "Mulgrave", region: "Eastern Suburbs" },
  { slug: "vermont", name: "Vermont", region: "Eastern Suburbs" },
  { slug: "vermont-south", name: "Vermont South", region: "Eastern Suburbs" },
  { slug: "forest-hill", name: "Forest Hill", region: "Eastern Suburbs" },
  { slug: "wantirna", name: "Wantirna", region: "Eastern Suburbs" },
  { slug: "wantirna-south", name: "Wantirna South", region: "Eastern Suburbs" },
  { slug: "ringwood", name: "Ringwood", region: "Outer East" },
  { slug: "ringwood-east", name: "Ringwood East", region: "Outer East" },
  { slug: "ringwood-north", name: "Ringwood North", region: "Outer East" },
  { slug: "croydon", name: "Croydon", region: "Outer East" },
  { slug: "croydon-hills", name: "Croydon Hills", region: "Outer East" },
  { slug: "croydon-north", name: "Croydon North", region: "Outer East" },
  { slug: "mooroolbark", name: "Mooroolbark", region: "Outer East" },
  { slug: "kilsyth", name: "Kilsyth", region: "Outer East" },
  { slug: "bayswater", name: "Bayswater", region: "Outer East" },
  { slug: "bayswater-north", name: "Bayswater North", region: "Outer East" },
  { slug: "boronia", name: "Boronia", region: "Outer East" },
  { slug: "ferntree-gully", name: "Ferntree Gully", region: "Outer East" },
  { slug: "upper-ferntree-gully", name: "Upper Ferntree Gully", region: "Outer East" },
  { slug: "scoresby", name: "Scoresby", region: "Outer East" },
  { slug: "knoxfield", name: "Knoxfield", region: "Outer East" },
  { slug: "rowville", name: "Rowville", region: "Outer East" },
  { slug: "the-basin", name: "The Basin", region: "Outer East" },
  { slug: "brighton", name: "Brighton", region: "Bayside & Frankston" },
  { slug: "brighton-east", name: "Brighton East", region: "Bayside & Frankston" },
  { slug: "hampton", name: "Hampton", region: "Bayside & Frankston" },
  { slug: "hampton-east", name: "Hampton East", region: "Bayside & Frankston" },
  { slug: "sandringham", name: "Sandringham", region: "Bayside & Frankston" },
  { slug: "black-rock", name: "Black Rock", region: "Bayside & Frankston" },
  { slug: "beaumaris", name: "Beaumaris", region: "Bayside & Frankston" },
  { slug: "cheltenham", name: "Cheltenham", region: "Bayside & Frankston" },
  { slug: "mentone", name: "Mentone", region: "Bayside & Frankston" },
  { slug: "mordialloc", name: "Mordialloc", region: "Bayside & Frankston" },
  { slug: "parkdale", name: "Parkdale", region: "Bayside & Frankston" },
  { slug: "aspendale", name: "Aspendale", region: "Bayside & Frankston" },
  { slug: "aspendale-gardens", name: "Aspendale Gardens", region: "Bayside & Frankston" },
  { slug: "edithvale", name: "Edithvale", region: "Bayside & Frankston" },
  { slug: "chelsea", name: "Chelsea", region: "Bayside & Frankston" },
  { slug: "bonbeach", name: "Bonbeach", region: "Bayside & Frankston" },
  { slug: "carrum", name: "Carrum", region: "Bayside & Frankston" },
  { slug: "patterson-lakes", name: "Patterson Lakes", region: "Bayside & Frankston" },
  { slug: "seaford", name: "Seaford", region: "Bayside & Frankston" },
  { slug: "frankston", name: "Frankston", region: "Bayside & Frankston" },
  { slug: "frankston-north", name: "Frankston North", region: "Bayside & Frankston" },
  { slug: "frankston-south", name: "Frankston South", region: "Bayside & Frankston" },
  { slug: "langwarrin", name: "Langwarrin", region: "Bayside & Frankston" },
  { slug: "carrum-downs", name: "Carrum Downs", region: "Bayside & Frankston" },
  { slug: "skye", name: "Skye", region: "Bayside & Frankston" },
  { slug: "dandenong", name: "Dandenong", region: "South-East & Inner South" },
  { slug: "dandenong-north", name: "Dandenong North", region: "South-East & Inner South" },
  { slug: "dandenong-south", name: "Dandenong South", region: "South-East & Inner South" },
  { slug: "noble-park", name: "Noble Park", region: "South-East & Inner South" },
  { slug: "keysborough", name: "Keysborough", region: "South-East & Inner South" },
  { slug: "springvale", name: "Springvale", region: "South-East & Inner South" },
  { slug: "springvale-south", name: "Springvale South", region: "South-East & Inner South" },
  { slug: "clayton", name: "Clayton", region: "South-East & Inner South" },
  { slug: "notting-hill", name: "Notting Hill", region: "South-East & Inner South" },
  { slug: "oakleigh", name: "Oakleigh", region: "South-East & Inner South" },
  { slug: "oakleigh-east", name: "Oakleigh East", region: "South-East & Inner South" },
  { slug: "oakleigh-south", name: "Oakleigh South", region: "South-East & Inner South" },
  { slug: "clarinda", name: "Clarinda", region: "South-East & Inner South" },
  { slug: "huntingdale", name: "Huntingdale", region: "South-East & Inner South" },
  { slug: "moorabbin", name: "Moorabbin", region: "South-East & Inner South" },
  { slug: "moorabbin-airport", name: "Moorabbin Airport", region: "South-East & Inner South" },
  { slug: "bentleigh", name: "Bentleigh", region: "South-East & Inner South" },
  { slug: "bentleigh-east", name: "Bentleigh East", region: "South-East & Inner South" },
  { slug: "mckinnon", name: "McKinnon", region: "South-East & Inner South" },
  { slug: "ormond", name: "Ormond", region: "South-East & Inner South" },
  { slug: "carnegie", name: "Carnegie", region: "South-East & Inner South" },
  { slug: "murrumbeena", name: "Murrumbeena", region: "South-East & Inner South" },
  { slug: "hughesdale", name: "Hughesdale", region: "South-East & Inner South" },
  { slug: "glen-huntly", name: "Glen Huntly", region: "South-East & Inner South" },
  { slug: "caulfield", name: "Caulfield", region: "South-East & Inner South" },
  { slug: "caulfield-north", name: "Caulfield North", region: "South-East & Inner South" },
  { slug: "caulfield-south", name: "Caulfield South", region: "South-East & Inner South" },
  { slug: "malvern", name: "Malvern", region: "South-East & Inner South" },
  { slug: "malvern-east", name: "Malvern East", region: "South-East & Inner South" },
  { slug: "armadale", name: "Armadale", region: "South-East & Inner South" },
  { slug: "berwick", name: "Berwick", region: "Outer South-East" },
  { slug: "narre-warren", name: "Narre Warren", region: "Outer South-East" },
  { slug: "narre-warren-north", name: "Narre Warren North", region: "Outer South-East" },
  { slug: "narre-warren-south", name: "Narre Warren South", region: "Outer South-East" },
  { slug: "cranbourne", name: "Cranbourne", region: "Outer South-East" },
  { slug: "cranbourne-north", name: "Cranbourne North", region: "Outer South-East" },
  { slug: "cranbourne-east", name: "Cranbourne East", region: "Outer South-East" },
  { slug: "cranbourne-west", name: "Cranbourne West", region: "Outer South-East" },
  { slug: "clyde", name: "Clyde", region: "Outer South-East" },
  { slug: "clyde-north", name: "Clyde North", region: "Outer South-East" },
  { slug: "officer", name: "Officer", region: "Outer South-East" },
  { slug: "pakenham", name: "Pakenham", region: "Outer South-East" },
  { slug: "beaconsfield", name: "Beaconsfield", region: "Outer South-East" },
  { slug: "endeavour-hills", name: "Endeavour Hills", region: "Outer South-East" },
  { slug: "hallam", name: "Hallam", region: "Outer South-East" },
  { slug: "hampton-park", name: "Hampton Park", region: "Outer South-East" },
  { slug: "lynbrook", name: "Lynbrook", region: "Outer South-East" },
  { slug: "lyndhurst", name: "Lyndhurst", region: "Outer South-East" },
  { slug: "doveton", name: "Doveton", region: "Outer South-East" },
  { slug: "eumemmerring", name: "Eumemmerring", region: "Outer South-East" },
  { slug: "bangholme", name: "Bangholme", region: "Outer South-East" },
  { slug: "waterways", name: "Waterways", region: "Outer South-East" },
  { slug: "chelsea-heights", name: "Chelsea Heights", region: "Outer South-East" },
  { slug: "botanic-ridge", name: "Botanic Ridge", region: "Outer South-East" },
  { slug: "junction-village", name: "Junction Village", region: "Outer South-East" },
  { slug: "pearcedale", name: "Pearcedale", region: "Outer South-East" },
  { slug: "blind-bight", name: "Blind Bight", region: "Outer South-East" },
  { slug: "tooradin", name: "Tooradin", region: "Outer South-East" },
  { slug: "mount-eliza", name: "Mount Eliza", region: "Mornington Peninsula" },
  { slug: "mornington", name: "Mornington", region: "Mornington Peninsula" },
  { slug: "mount-martha", name: "Mount Martha", region: "Mornington Peninsula" },
  { slug: "safety-beach", name: "Safety Beach", region: "Mornington Peninsula" },
  { slug: "dromana", name: "Dromana", region: "Mornington Peninsula" },
  { slug: "rosebud", name: "Rosebud", region: "Mornington Peninsula" },
  { slug: "rye", name: "Rye", region: "Mornington Peninsula" },
  { slug: "blairgowrie", name: "Blairgowrie", region: "Mornington Peninsula" },
  { slug: "sorrento", name: "Sorrento", region: "Mornington Peninsula" },
  { slug: "somerville", name: "Somerville", region: "Mornington Peninsula" },
  { slug: "tyabb", name: "Tyabb", region: "Mornington Peninsula" },
  { slug: "hastings", name: "Hastings", region: "Mornington Peninsula" },
  { slug: "bittern", name: "Bittern", region: "Mornington Peninsula" },
  { slug: "crib-point", name: "Crib Point", region: "Mornington Peninsula" },
  { slug: "melton", name: "Melton", region: "Outer Growth Areas & Surrounds" },
  { slug: "melton-south", name: "Melton South", region: "Outer Growth Areas & Surrounds" },
  { slug: "melton-west", name: "Melton West", region: "Outer Growth Areas & Surrounds" },
  { slug: "kurunjang", name: "Kurunjang", region: "Outer Growth Areas & Surrounds" },
  { slug: "brookfield", name: "Brookfield", region: "Outer Growth Areas & Surrounds" },
  { slug: "toolern-vale", name: "Toolern Vale", region: "Outer Growth Areas & Surrounds" },
  { slug: "bacchus-marsh", name: "Bacchus Marsh", region: "Outer Growth Areas & Surrounds" },
  { slug: "sunbury", name: "Sunbury", region: "Outer Growth Areas & Surrounds" },
  { slug: "diggers-rest", name: "Diggers Rest", region: "Outer Growth Areas & Surrounds" },
  { slug: "mickleham", name: "Mickleham", region: "Outer Growth Areas & Surrounds" },
  { slug: "kalkallo", name: "Kalkallo", region: "Outer Growth Areas & Surrounds" },
  { slug: "donnybrook", name: "Donnybrook", region: "Outer Growth Areas & Surrounds" },
  { slug: "greenvale", name: "Greenvale", region: "Outer Growth Areas & Surrounds" },
  { slug: "attwood", name: "Attwood", region: "Outer Growth Areas & Surrounds" },
  { slug: "westmeadows", name: "Westmeadows", region: "Outer Growth Areas & Surrounds" },
  { slug: "jacana", name: "Jacana", region: "Outer Growth Areas & Surrounds" },
  { slug: "keilor-downs", name: "Keilor Downs", region: "Outer Growth Areas & Surrounds" },
  { slug: "kings-park", name: "Kings Park", region: "Outer Growth Areas & Surrounds" },
  { slug: "st-albans", name: "St Albans", region: "Outer Growth Areas & Surrounds" },
  { slug: "st-albans-south", name: "St Albans South", region: "Outer Growth Areas & Surrounds" },
  { slug: "derrimut", name: "Derrimut", region: "Outer Growth Areas & Surrounds" },
  { slug: "sanctuary-lakes", name: "Sanctuary Lakes", region: "Outer Growth Areas & Surrounds" },
  { slug: "seabrook", name: "Seabrook", region: "Outer Growth Areas & Surrounds" },
  { slug: "werribee", name: "Werribee", region: "Outer Growth Areas & Surrounds" },
  { slug: "werribee-south", name: "Werribee South", region: "Outer Growth Areas & Surrounds" },
  { slug: "little-river", name: "Little River", region: "Outer Growth Areas & Surrounds" },
  { slug: "somerton", name: "Somerton", region: "Outer Growth Areas & Surrounds" },
  { slug: "geelong", name: "Geelong", region: "Outer Growth Areas & Surrounds" },
];

export const REGIONS = [
  "Inner Melbourne & CBD",
  "North & North-West",
  "West & Western Suburbs",
  "North-East Suburbs",
  "Inner East",
  "Eastern Suburbs",
  "Outer East",
  "Bayside & Frankston",
  "South-East & Inner South",
  "Outer South-East",
  "Mornington Peninsula",
  "Outer Growth Areas & Surrounds",
];

export const findSuburb = (slug) => SUBURBS.find((s) => s.slug === slug);

export const suburbsByRegion = () =>
  REGIONS.map((region) => ({ region, suburbs: SUBURBS.filter((s) => s.region === region) }));
